import React, { useEffect } from 'react';
import { Img } from 'react-image';
import { Button } from 'flowbite-react';
import classNames from 'classnames';
import { setDataForGithubInLocalStorage } from '../../utils/integrations';
import Container from 'src/components/shared/Container';
import { API_ENDPOINT, APP_ENDPOINT } from 'src/config/env.config';
import ContributionGraph from 'src/components/githubDetails/ContributionGraph';
import { UIUser } from 'types';
import { useToast } from 'src/context/ToastProvider';
import { FaGithub } from 'react-icons/fa6';
import ProfileContentHeader from 'src/components/profile/ProfileContentHeader';

type Props = {
	title: string;
	data: UIUser;
	id?: string;
	isSelf?: boolean | null;
	isEditing?: boolean;
};

const SocialAccount = ({ title, isSelf, data, id }: Props) => {
	const toast = useToast();
	const connectGitHub = async () => {
		try {
			setDataForGithubInLocalStorage(data?._id, `${APP_ENDPOINT}/profile/${data.handler}`);
			window.open(`${API_ENDPOINT}/github`, '_self');
		} catch (e) {
			console.log(e);
		}
	};

	const isGitHubConnected = !!data.flags.isGitHubConnected;

	useEffect(() => {
		const githubDetails = JSON.parse(localStorage.getItem('githubConnect') || '{}');
		if (
			!isGitHubConnected &&
			Object.keys(githubDetails).length > 0 &&
			githubDetails.isForGitHubConnect &&
			githubDetails.userId
		) {
			// show error toast saying something went wrong and delete the key from localstorage
			toast({
				type: 'error',
				title: "Oops, your LevelUp email id and Github don't match. Contact support@levelup.inc",
			});
			localStorage.removeItem('githubConnect');
		}
		localStorage.removeItem('githubConnect');
		localStorage.removeItem('linkedInConnect');
	}, []);

	return (
		<>
			<ProfileContentHeader data={{ name: title, isImp: false }} />
			<div id={id} className={`overflow-hidden rounded-xl bg-transparent dark:bg-[#1F2A37] text-[#FAFAFC] p-3`}>
				{isSelf && !isGitHubConnected && (
					<Container className="w-[95%] max-w-[1366px] pb-10 sm:w-[96%] sm:pb-2">
						<div className="py-5 pb-[10px] sm:hidden ">
							<div className="mt-[2px] w-[535px] text-sm text-[#1C1C28] dark:text-[#C7C9D9]">
								Connect your account with third-party apps for a seamless experience.
							</div>
						</div>

						<div className="px-auto flex flex-col gap-2">
							<div className="flex h-[88px] max-w-full justify-between rounded-[8px] bg-transparent dark:bg-[#1F2A37] p-4 sm:h-auto sm:gap-x-3">
								<div className="flex max-w-[120px] items-center justify-center sm:items-start sm:pt-1">
									<FaGithub className="w-[56px] h-[56px] text-black dark:text-white" />
								</div>
								<div className="items-between ml-4 flex w-full flex-grow flex-col justify-between sm:ml-1 sm:gap-[6px] md:flex-row">
									<div className="flex flex-col justify-between py-1">
										<div className="flex gap-2">
											<div className="text-base font-medium text-black dark:text-white">GitHub</div>
											{isGitHubConnected && (
												<div className="flex w-max items-center gap-2 rounded-[99px] bg-[#014737] px-[10px] py-[4px] text-xs font-medium text-[#84E1BC]">
													<div className="h-3 w-3 rounded-[99px] bg-[#0E9F6E]"></div>
													Connected
												</div>
											)}
										</div>
										<div className="text-xs text-black dark:text-[#C7C9D9]">
											Boost your presence by connecting your GitHub account
										</div>
									</div>
									{!isGitHubConnected && (
										<div className="flex items-center">
											<Button
												color="purplePlaced"
												className={classNames({
													'!bg-[#18222D] hover:cursor-not-allowed': isGitHubConnected,
												})}
												disabled={isGitHubConnected}
												onClick={connectGitHub}
											>
												Connect
											</Button>
										</div>
									)}
								</div>
							</div>

							<div className="font-inter text-[12px] italic text-black dark:text-[#C7C9D9]">
								*Kindly ensure that your LevelUp email ID matches your Social account email ID.
							</div>
						</div>
					</Container>
				)}
				{isGitHubConnected && (
					<div className="!w-[100%] max-w-[1366px] overflow-hidden rounded-t-[8px] pb-10 sm:!w-full !px-2">
						<ContributionGraph userId={data._id} isSelf={isSelf || false} />
					</div>
				)}
			</div>
		</>
	);
};

export default SocialAccount;
